import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

const Disclaimer = () => (
  <div className="p-6 max-w-3xl mt-20 mx-auto">
    <h1 className="text-2xl font-bold mb-4">Disclaimer</h1>
    <p className="text-gray-700 mb-4">
      The information provided on Organic Pads' website is for general informational purposes only.
      We do not guarantee the accuracy, completeness, or reliability of any information presented.
    </p>
    <p className="text-gray-700">Use of our products is at your own risk.</p>
  </div>
);

const CookiePolicy = () => (
  <div className="p-6 max-w-3xl mt-20 mx-auto">
    <h1 className="text-2xl font-bold mb-4">Cookie Policy</h1>
    <p className="text-gray-700 mb-4">
      Our website uses cookies to enhance user experience and analyze site traffic. By using our website, you consent
      to the use of cookies in accordance with our policy.
    </p>
  </div>
);

export { Disclaimer, CookiePolicy };
